import Department from "../types/Department";
import DepartmentFilter from "../types/filters/DepartmentFilter";

export function applyDepartmentFilter(departments: Department[], filter: DepartmentFilter): Department[] {
    let filteredDepartments = departments;

    if (filter.searchText) {
        const upperCaseSearchText = filter.searchText.toUpperCase();

        filteredDepartments = filteredDepartments.filter(
            (d) =>
                d.name.toUpperCase().includes(upperCaseSearchText) ||
                d.abbreviation.toUpperCase().includes(upperCaseSearchText)
        );
    }

    return filteredDepartments;
}
